import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { FacultyService } from '../faculty.service';

@Component({
  selector: 'app-newperiod-image-dialog',
  templateUrl: './newperiod-image-dialog.component.html',
  styleUrls: ['./newperiod-image-dialog.component.scss']
})
export class NewperiodImageDialogComponent {
  startTime: any;
  endTime: any;
  image: any;
  currentIndex: any = 0;
  date: any;

    rotation = 0;

  constructor(private spinner: NgxSpinnerService, @Inject(MAT_DIALOG_DATA) public data: any, private matdialofRef: MatDialogRef<NewperiodImageDialogComponent>, private http: FacultyService) { }
  ngOnInit(): void {
    // console.log('DATAIMAGE',this.data)
    this.startTime = this.data.time.split(", ")[1];
    this.endTime = this.data.endTime.split(", ")[1];
    this.date = this.data.time.split(", ")[0];
    if (this.data.imageList.length > 0) {
      this.currentIndex = 0;
      this.getImage();
    }

  }

  getImage() {
    this.spinner.show()
    this.http.getPeriodImage(this.data.payrollId, this.data.imageList[this.currentIndex].imagePath).subscribe({
      next: (res: any) => {
        if (!res) {
          this.spinner.hide();
          return;
        }
        this.image = URL.createObjectURL(res);
        this.spinner.hide();
      },
      error: (err: any) => {
        console.error(err)
        this.spinner.hide()
      }
    })
  }

  nextImage() {
    if (this.currentIndex < this.data.imageList.length - 1 && this.data.imageList.length > 0) {
      this.currentIndex++;
      this.getImage();
    }
  }

  previousImage() {
    if (this.currentIndex > 0 && this.data.imageList.length > 0) {
      this.currentIndex--;
      this.getImage();
    }
  }

    rotateImage() {
    this.rotation = (this.rotation + 90) % 360;
  }

  close() {
    this.matdialofRef.close()
  }
}
